/**
 * Domain Adapter — Smart City (CityGML 3.0)
 *
 * Phase-2 deliverable. Covers urban 3D Tiles / CityGML assets including
 * smart city districts. Not-yet-implemented; returns an explicit typed error.
 *
 * See registry.ts: default domain is "smartcity"; 3D Tiles + Japan CRS also
 * maps to "smartcity".
 */

import type { SceneItem } from "@/sdk-stub/gtwin-sdk/types";
import type { DomainAdapter, DomainAdapterContext, AdapterResult } from "../DomainAdapter";

export const CityGmlAdapter: DomainAdapter = {
  domain: "smartcity",
  version: "1.0.0",
  standard: "CityGML:3.0",

  /**
   * Detects CityGML / smart-city 3D Tiles assets.
   * Matches `layerKind === "3dtiles"` or `"citygml"`, or explicit domain extension.
   */
  detect(item: SceneItem): boolean {
    type Extended = SceneItem & { extensions?: { geosoft?: { domain?: string } } };
    const ext = (item as Extended).extensions?.geosoft;
    if (ext?.domain === "smartcity") return true;
    return item.layerKind === "3dtiles" || item.layerKind === "citygml";
  },

  async buildManifest(
    _item: SceneItem,
    _asset: { layerId: string; assetNodeId: string; gtwinId: string },
    _context: DomainAdapterContext,
  ): Promise<AdapterResult> {
    return {
      ok: false,
      error: {
        kind: "not-implemented",
        domain: "smartcity",
        message:
          "Phase 2 deliverable; fall back to synthetic Tier-1 view.",
      },
    };
  },
};
